<template>
  <card title="Backorder Order" headerStyle="primary" bodyClasses="py-3 px-0">
    <div class="row px-3">
      <div class="col-lg-6">
        <jet-button class="btn-sm" :goesTo="orderRoute" tabindex="-1" icon="fas fa-angle-right">View BackOrder</jet-button>
      </div>
      <div class="col-lg-6" v-if="order">
        <card bodyClasses="py-3 px-0">
          <OrderTable 
            :order="order"
            :items="items"
            :productRoute="productRoute"
            :backorderItems="[]"
            :isWholesale="order.user.id == $page.props.auth.user.id"
          >
          </OrderTable>
        </card>
      </div>
    </div>
  </card>
</template>

<script>
  import JetButton from '@/Jetstream/Button'
  import OrderTable from '@/Components/Shop/OrderTable'

  export default {
    components: {
      OrderTable,
      JetButton
    },
    props: {
      orderRoute: String,
      productRoute: String,
      order: Object,
    },
    computed: {
      items() {
        return this.order ? this.order.items : []
      }
    }
  }
</script>
